import { Coordinate, GUID, Param } from "app/brightserve/brightserve.module";

import { Person } from "./person";
import { Observation } from "./observation";

export class Incident {

    Id: GUID;
    PatientName: string;
    ClientName: string;
    IncidentNumber: string;
    EnteredBy: string;

    StartDate?: Date;
    Type: Param;
    Status: Param;
    Description: string;
    Patient: Person;
    Location: Coordinate;
    Observations: Observation[];
    IncidentFilename: string;

    constructor(init?: Partial<Incident>) {
        Object.assign(this, init);

        if (init && init.Type) {
            this.Type = new Param(init.Type);
        } else {
            this.Type = null;
        };

        if (init && init.Status) {
            this.Status = new Param(init.Status);
        } else {
            this.Status = null;
        };

        if (init && init.Patient) {
            this.Patient = new Person(init.Patient);
        } else {
            this.Patient = null;
        };

        if (init && init.Location) {
            this.Location = new Coordinate(init.Location);
        } else {
            this.Location = null;
        };

        if (init && init.Observations) {
            this.Observations = init.Observations.map(m => new Observation(m));
        } else {
            this.Observations = new Array<Observation>()
        };
    }

    static NewIncident(): Incident {
        return new Incident({ Id: GUID.newGuid(), IncidentNumber: this.GenerateCaseNumber(), StartDate: new Date(), Type: new Param({ Entity: "Incident", Field: "Type", Value: "Normal" }), Status: new Param({ Entity: "Incident", Field: "Status", Value: "Current" }), Location: new Coordinate() });
    }

    private static GenerateCaseNumber(): any {
        var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        var str = "CASE-####-####-####";
        return str.replace(/[#]/g, function () {
            return chars[Math.floor(Math.random() * chars.length)];
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/incident.ts